/* eslint-disable */
module.exports = require('dataparcels/validation.js');
